import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import { _ } from '/@/locale';
import { getGroups } from '/@/utils';
import styles from './styles.module.css';

@autobind
export default class Notes extends Component {
    static propTypes = {
        notes: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                text: PropTypes.object,
            })
        ),
        columns: PropTypes.number,
    };

    static defaultProps = {
        columns: 1,
    };

    render() {
        const groups = getGroups(this.props.notes, this.props.columns);
        const width = `${100 / (groups.length || 1)}%`;

        return (
            <div className={styles.root}>
                {groups.map((notes, index) => (
                    <ul key={`group-${index}`} style={{ width }} className={styles.column}>
                        {notes.map((text) => (
                            <li key={text}>
                                <i className='material-icons'>arrow_right</i>
                                <ReactMarkdown className={styles.text}>{_(text.text)}</ReactMarkdown>
                            </li>
                        ))}
                    </ul>
                ))}
            </div>
        );
    }
}
